import { NgModule, APP_INITIALIZER }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { ProjectsSearchComponent, ProposalsSearchComponent, ProposalsPeSearchComponent } from './projects-search.component';
import { ProjectsListComponent, ProposalsListComponent, ProposalsPeListComponent } from './projects-list/projects-list.component';
import { ProjectsFiltersComponent } from './projects-filters/projects-filters.component';
import { ProjectsResumeComponent } from './projects.resume/projects.resume.component';
import { FilterDialogModule } from './projects-filters/filter-dialog/filter-dialog.module';

import { AngularMaterialModule } from '../angular-material.module';

import { ListService } from './services/list.service';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports:      [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    FilterDialogModule,
    TranslateModule
  ],
  declarations: [
    ProjectsSearchComponent,
    ProjectsListComponent,
    ProposalsListComponent,
    ProposalsPeListComponent,
    ProjectsFiltersComponent,
    ProposalsSearchComponent,
    ProposalsPeSearchComponent,
    ProjectsResumeComponent
  ],
  exports:      [
    ProjectsSearchComponent,
    ProposalsSearchComponent,
    ProposalsPeSearchComponent
  ],
  providers:    [ 
    ListService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ]
})
export class ProjectsSearchModule { }
